import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TimeagoPipe } from '@apply4u/shared/pipes/timeago.pipe';
import { SmartJobCardComponent } from './smart-job-card.component';
import { FormsModule } from '@angular/forms';
import { LocalDateTimePipe } from '@apply4u/shared/pipes/local-date-time.pipe';
import { JobWishListModalModule } from '../job-wish-list-modal/job-wish-list-modal.module';
import { ShareJobModalModule } from '../share-job-modal/share-job-modal.module';
import { CompanyProfileUrlPipe } from '@apply4u/shared/pipes/company-profile-url.pipe';
import { RecommendationsModalModule } from '../recommendations-modal/recommendations-modal.module';
import { HighlightPipe } from '@apply4u/shared/pipes/highlight.pipe';
import { HighlightsPipe } from '@apply4u/shared/pipes/highlights.pipe';
import { JobDetailUrlSmartPipe } from '@apply4u/shared/pipes/job-detail-url-smart.pipe';
import { JobSearchDetailPipe } from '@apply4u/shared/pipes/job-search-detail.pipe';
import { LocalDatePipe } from '@apply4u/shared/pipes/local-date.pipe';
import { RemoveImageTagsPipe } from '@apply4u/shared/pipes/remove-image-tags.pipe';
import { SafeHtmlPipe } from '@apply4u/shared/pipes/safehtml.pipe';

@NgModule({
  declarations: [
    SmartJobCardComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HighlightPipe,
    HighlightsPipe,
    TimeagoPipe,
    SafeHtmlPipe,
    RemoveImageTagsPipe,
    LocalDateTimePipe,
    JobDetailUrlSmartPipe,
    JobWishListModalModule,   
    ShareJobModalModule,
    CompanyProfileUrlPipe,
    LocalDatePipe,
    JobSearchDetailPipe,
    RecommendationsModalModule
  ],
  exports : [
    SmartJobCardComponent,
  ]
})
export class SmartJobCardModule { }
